
(function ($, Drupal) {
/**
 * @param {string} menu
 *   The css selector for the boostrap tab.
 */
Drupal.autoCollapse = function (menu) {

  let nav = $(menu)
  if(nav.length > 0){
    const screenWidth = window.screen.width;
    let navWidth = nav[0].scrollWidth
    let maxWidth = (screenWidth <= 768)
      ? $(window).width()
      : $(nav[0]).parent().innerWidth();

    if (navWidth >= maxWidth) {
      if($(menu + ' .dropdown').length < 1){
        $('<li class="nav-item dropdown d-none">\n' +
          '   <a class="nav-link  dropdown-toggle" href="#" id="DropdownMenu" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">\n' +
          '   More\n' +
          '   </a>\n' +
          '  <ul class="dropdown-menu p-2 dropdown-menu-right" aria-labelledby="DropdownMenu" style="">' +
          ' </ul>\n' +
          '</li>').appendTo(menu)
      }

      $(menu + ' .dropdown').removeClass('d-none');
      $(".navbar-nav").removeClass('w-auto').addClass("w-100");

      while (navWidth > maxWidth) {
        //  add child to dropdown
        let children = nav.children(menu + ' li:not(:last-child)');
        let count = children.length;
        $(children[count - 1]).prependTo(menu + ' .dropdown-menu');
        navWidth = nav[0].scrollWidth;
      }
      $(".navbar-nav").addClass("w-auto").removeClass('w-100');

    } else {

      let collapsed = $(menu + ' .dropdown-menu').children(menu + ' li');

      if (collapsed.length === 0) {
        $(menu + ' .dropdown').addClass('d-none');
      }

      while (navWidth < maxWidth && (nav.children(menu + ' li').length > 0) && collapsed.length > 0) {
        //  remove child from dropdown
        collapsed = $(menu + ' .dropdown-menu').children('li');
        $(collapsed[0]).insertBefore(nav.children(menu + ' li:last-child'));
        navWidth = nav[0].scrollWidth;
        if(!$(menu + ' .dropdown-menu').children('li').length){
         $(menu + ' li:last-child').addClass('d-none');
        }
      }
      
      if (navWidth > maxWidth) {
        Drupal.autoCollapse(menu);
      }
    }

  }
};
})(jQuery, Drupal);
